<!-- <div class="main-content">
  <div class="sub-content">

    <div>
      <mat-form-field *ngFor="let filter of filterSelectObj" style="margin-left: 15px;">
        <mat-label>Filter {{filter.name}}</mat-label>
        <select matNativeControl name="{{filter.columnProp}}" [(ngModel)]="filter.modelValue"
          (change)="filterChange(filter,$event)">
          <option value="">-- Select {{filter.name}} --</option>
          <option [value]="item" *ngFor="let item of filter.options">{{item}}</option>
        </select>
      </mat-form-field>
      &nbsp;
      <button mat-flat-button color="warn" (click)="resetFilters()">Reset</button>
    </div>

    <div class="table-content">

      <table class="table table-striped" mat-table [dataSource]="documentView">

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>  </th>
          <td mat-cell *matCellDef="let element">  <div [ngClass]="element.type" class="icon"></div> </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> {{'DOCUMENTS.TITLE' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
        </ng-container>

        <ng-container matColumnDef="dateModified">
          <th mat-header-cell *matHeaderCellDef> {{'DOCUMENTS.DATE' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{ element.dateModified | appDate: 'mediumDate'  }} </td>
        </ng-container>

        <ng-container matColumnDef="author">
          <th mat-header-cell *matHeaderCellDef> {{'DOCUMENTS.AUTHORS' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{ element.author }}</td>
        </ng-container>

        <ng-container matColumnDef="type_doc">
          <th mat-header-cell *matHeaderCellDef> {{'DOCUMENTS.TYPE' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{ element.type_doc }}</td>
        </ng-container>

        <ng-container matColumnDef="theme">
          <th mat-header-cell *matHeaderCellDef> {{'DOCUMENTS.THEME' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{ element.theme }}</td>
        </ng-container>

        <ng-container matColumnDef="allSourcefin">
          <th mat-header-cell *matHeaderCellDef> {{'DOCUMENTS.PAD' | translate}} </th>
          <td mat-cell *matCellDef="let element">
            <span *ngFor="let pad of element.allSourcefin ; let index = index; let isFirsta = first; let isOdda = odd;">
              {{isOdda ? pad[1] : pad[1]+' , '}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="allSector">
          <th mat-header-cell *matHeaderCellDef> {{'DOCUMENTS.SECTOR' | translate}} </th>
          <td mat-cell *matCellDef="let element">
            <span *ngFor="let sector of element.allSector ; let index = index; let isFirstb = first; let isOddb = odd;">
              {{isOddb ? sector[1] : sector[1]+' , '}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="download">
          <th mat-header-cell *matHeaderCellDef>{{'DOCUMENTS.DOWNLOAD' | translate}} </th>
          <td mat-cell *matCellDef="let element">
            <a (click)="downloadItem(element)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7366 2.76175H8.08461C6.00461 2.75375 4.30061 4.41075 4.25061 6.49075V17.2277C4.20561 19.3297 5.87361 21.0697 7.97461 21.1147C8.01161 21.1147 8.04861 21.1157 8.08461 21.1147H16.0726C18.1626 21.0407 19.8146 19.3187 19.8026 17.2277V8.03775L14.7366 2.76175Z" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14.4749 2.75V5.659C14.4749 7.079 15.6239 8.23 17.0439 8.234H19.7979" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M11.6409 9.90869V15.9497" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.9866 12.2642L11.6416 9.90918L9.2966 12.2642" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

    </div>

  </div>
</div>



<br><br><br><br>
<br><br><br><br> -->



<!-- <div class="main-content" #content>
  <div class="space"></div>
  <div class="sub-content">
    <div class="table-content" *ngIf="documentView.length > 0 && !loading">
      <table class="table table-striped" show-filter=true>
        <thead>
        <tr>
          <th scope="col"  sortable="type" (sort)="onSort($event)" style="width: 50px"></th>
          <th scope="col" class="filtres"  sortable="name" (sort)="onSort($event)">{{'DOCUMENTS.TITLE' | translate}}</th>
          <th scope="col" class="filtre only-large-screen" sortable="dateModified"  (sort)="onSort($event)" style="width: 100px">{{'DOCUMENTS.DATE' | translate}}</th>
          <th scope="col" class="filtre only-large-screen"  sortable="author" (sort)="onSort($event)">{{'DOCUMENTS.AUTHORS' | translate}}</th>
          <th scope="col" class="filtre only-large-screen" sortable="type_doc" (sort)="onSort($event)">{{'DOCUMENTS.TYPE' | translate}}</th>

          <th scope="col" class="filtre only-large-screen" sortable="theme" (sort)="onSort($event)">{{'DOCUMENTS.THEME' | translate}}</th>

          <th scope="col" class="filtre only-large-screen" sortable="allSourcefin" (sort)="onSort($event)" style="width: 160px" >{{'DOCUMENTS.PAD' | translate}}</th>
          <th scope="col" class="filtre only-large-screen" sortable="allSector" (sort)="onSort($event)">{{'DOCUMENTS.SECTOR' | translate}}</th>

          <th  style="width: 60px; text-align: center">{{'DOCUMENTS.DOWNLOAD' | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let document of documentView">
          <td >
            <div [ngClass]="document.type" class="icon"></div>
          </td>
          <td>
            {{ document.name }}
          </td>
          <td class="only-large-screen">{{ document.dateModified | appDate: 'mediumDate'  }}</td>
          <td class="only-large-screen">{{ document.author }}</td>
          <td class="only-large-screen">{{ document.type_doc}}</td>
          <td class="only-large-screen">{{ document.theme }}</td>

          <td class="only-large-screen">
            <span *ngFor="let pad of document.allSourcefin ; let index = index; let isFirsta = first; let isOdda = odd;">
              <!-- {{isFirsta}}
              {{isOdda}}
              {{document.allSourcefin.length}} 
              {{(document.allSourcefin.length==1 || index == (document.allSourcefin.length-1)) ? pad[1] : pad[1]+',  '}}
            </span>
          </td>
          <td class="only-large-screen">
            <span *ngFor="let sector of document.allSector ;let index = index; let isFirstb = first; let isOddb = odd;">
              <br>
              {{(document.allSector.length==1 || index == (document.allSector.length-1)) ? sector[1] : sector[1]+',  '}}

            </span>
          </td>

          <td class="download">
            <a (click)="downloadItem(document)">
              <svg width="24" height="24" fill="#1D6529" stroke="#1D6529"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill-rule="evenodd" clip-rule="evenodd" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>


              <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7366 2.76175H8.08461C6.00461 2.75375 4.30061 4.41075 4.25061 6.49075V17.2277C4.20561 19.3297 5.87361 21.0697 7.97461 21.1147C8.01161 21.1147 8.04861 21.1157 8.08461 21.1147H16.0726C18.1626 21.0407 19.8146 19.3187 19.8026 17.2277V8.03775L14.7366 2.76175Z" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14.4749 2.75V5.659C14.4749 7.079 15.6239 8.23 17.0439 8.234H19.7979" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.6409 9.90869V15.9497" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.9866 12.2642L11.6416 9.90918L9.2966 12.2642" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg> 
              
            </a>

          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="paging-content" *ngIf="documentView.length > 0 && !loading">
      <div class="paging">
        <div class="first-page" *ngIf="currentPage !== 1">
          <button (click)="currentPage = 1"> << </button>
        </div>
        <div class="prev-page"  *ngIf="currentPage !== 1">
          <button (click)="currentPage = currentPage - 1"> < </button>
        </div>
        <div  *ngFor="let page of pages">
          <button [ngClass]="currentPage === page ? 'active' : ''" (click)="currentPage = page">{{page}}</button>
        </div>
        <div class="next-page" *ngIf="currentPage !== pages.length">
          <button (click)="currentPage = currentPage + 1"> > </button>
        </div>
        <div class="last-page"  *ngIf="currentPage !== pages.length">
          <button (click)="currentPage = pages.length"> >> </button>
        </div>
      </div>
      <div class="summary">
        <span>  {{'DOCUMENTS.PAGING' | translate: {current: currentPage,  total: pages.length,  files: documents.length } }}</span>
      </div>
    </div>
    <div *ngIf="documentView.length === 0 && !loading">
      <h2>{{'COMMON.NO_DATA' | translate}}</h2>
    </div>
  </div>
  <div class="space"></div>
</div> -->


<form  novalidate #form="ngForm">
  <div class="main-content" #content>
    <div class="space"></div>
    <div class="sub-content">
      <div class="table-content" *ngIf="documentView.length > 0 && !loading">
        <table class="table table-striped" show-filter=true>
          <thead>
            <tr>
              <th scope="col" sortable="type" (sort)="onSort($event)" style="width: 50px"></th>
  
              <th scope="col" class="filtre  filtres no-padding-bottom" >
                <!-- <th scope="col" class="filtres" sortable="name" (sort)="onSort($event)"> -->
                <!-- {{'DOCUMENTS.TITLE' | translate}}  (ngModelChange)="inputChange($event, 'name')"-->
                  <!-- <mat-hint>{{'DOCUMENTS.TITLE' | translate}}</mat-hint> -->
                  <div style="display: flex;">
                    <mat-form-field appearance="legacy">
                      <mat-icon matSuffix style="font-size:x-small;">filter_list</mat-icon>
                      <input type="text"
                            placeholder="{{'DOCUMENTS.TITLE' | translate}}"
                            aria-label="Number"
                            matInput
                            [(ngModel)]="name"
                            name="name"
                            [formControl]="myControlTitle"
                            [matAutocomplete]="auto"
                            (keyup)="inputChange($event, 'name')"
                            [id]="name" 
                            
                            >
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let name of filteredOptions | async" [value]="name">
                          {{name}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>

                    <th  class="sorticone" sortable="name" (sort)="onSort($event)"> </th>
                  </div>
                  
              </th>
              <th scope="col" class="filtre only-large-screen filtres no-padding-bottom" style="width: 80px">
                <!-- {{'DOCUMENTS.DATE' | translate}} -->
                <div style="display: flex;">
                  <mat-form-field appearance="legacy" style="width: 80px">
                    <mat-icon matSuffix style="font-size:x-small;">filter_list</mat-icon>
                    <input type="text"
                          placeholder="{{'DOCUMENTS.DATE' | translate}}"
                          aria-label="Number"
                          matInput
                          [(ngModel)]="dateModified"
                          name="dateModified"
                          [formControl]="myControlTitle"
                          [matAutocomplete]="auto"
                          (keyup)="inputChange($event, 'dateModified')"
                          [id]="dateModified" 
                          
                          >
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option *ngFor="let infos of filteredOptions | async" [value]="name">
                        {{name}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <th  class="sorticone" sortable="dateModified" (sort)="onSort($event)"> </th>
                </div>

              </th>
              <th scope="col" class="filtre only-large-screen filtres no-padding-bottom" >
                <!-- {{'DOCUMENTS.AUTHORS' | translate}} -->
                <div style="display: flex;">
                  <mat-form-field appearance="legacy" style="width:100px">
                    <mat-icon matSuffix style="font-size:x-small;">filter_list</mat-icon>
                    <input type="text"
                          placeholder="{{'DOCUMENTS.AUTHORS' | translate}}"
                          aria-label="Number"
                          matInput
                          [(ngModel)]="author"
                          name="author"
                          [formControl]="myControlTitle"
                          [matAutocomplete]="auto"
                          (keyup)="inputChange($event, 'author')"
                          [id]="author" 
                          >
                    <!-- <mat-autocomplete #auto="matAutocomplete">
                      <mat-option *ngFor="let infos of filteredOptions | async" [value]="name">
                        {{name}}
                      </mat-option>
                    </mat-autocomplete> -->
                  </mat-form-field>
                  <th  class="sorticone" sortable="author" (sort)="onSort($event)"> </th>
                </div>

              </th>
              <th scope="col" class="filtre only-large-screen" >
                <!-- {{'DOCUMENTS.TYPE' | translate}} -->
                <div style="display: flex;">
                  <mat-form-field appearance="legacy">
                    <mat-icon matSuffix style="font-size:x-small;">filter_list</mat-icon>
                    <input type="text"
                          placeholder="{{'DOCUMENTS.TYPE' | translate}}"
                          aria-label="Number"
                          matInput
                          [(ngModel)]="type_doc"
                          name="type_doc"
                          [formControl]="myControlTitle"
                          [matAutocomplete]="auto"
                          (keyup)="inputChange($event, 'type_doc')"
                          [id]="type_doc" 
                          >
                    <!-- <mat-autocomplete #auto="matAutocomplete">
                      <mat-option *ngFor="let infos of filteredOptions | async" [value]="name">
                        {{name}}
                      </mat-option>
                    </mat-autocomplete> -->
                  </mat-form-field>
                  <th  class="sorticone" sortable="type_doc" (sort)="onSort($event)"> </th>
                </div>
              </th>
  
              <th scope="col" class="filtre only-large-screen" >
                <!-- {{'DOCUMENTS.THEME' | translate}} -->
                <div style="display: flex;">
                  <mat-form-field appearance="legacy">
                    <mat-icon matSuffix style="font-size:x-small;">filter_list</mat-icon>
                    <input type="text"
                          placeholder="{{'DOCUMENTS.THEME' | translate}}"
                          aria-label="Number"
                          matInput
                          [(ngModel)]="theme"
                          name="theme"
                          [formControl]="myControlTitle"
                          [matAutocomplete]="auto"
                          (keyup)="inputChange($event, 'theme')"
                          [id]="theme" 
                          >
                    <!-- <mat-autocomplete #auto="matAutocomplete">
                      <mat-option *ngFor="let infos of filteredOptions | async" [value]="name">
                        {{name}}
                      </mat-option>
                    </mat-autocomplete> -->
                  </mat-form-field>
                  <th  class="sorticone" sortable="theme" (sort)="onSort($event)"> </th>
                </div>
              </th>
  
              <th scope="col" class="filtre only-large-screen" style="width: 160px">
                <!-- {{'DOCUMENTS.PAD' | translate}} -->
                <div style="display: flex;">
                  <mat-form-field appearance="legacy">
                    <mat-icon matSuffix style="font-size:x-small;">filter_list</mat-icon>
                    <input type="text"
                          placeholder="{{'DOCUMENTS.PAD' | translate}}"
                          aria-label="Number"
                          matInput
                          [(ngModel)]="allSourcefin"
                          name="allSourcefin"
                          [formControl]="myControlTitle"
                          [matAutocomplete]="auto"
                          (keyup)="inputChange($event, 'allSourcefin')"
                          [id]="allSourcefin" 
                          >
                    <!-- <mat-autocomplete #auto="matAutocomplete">
                      <mat-option *ngFor="let infos of filteredOptions | async" [value]="name">
                        {{name}}
                      </mat-option>
                    </mat-autocomplete> -->
                  </mat-form-field>
                  <th  class="sorticone" sortable="allSourcefin" (sort)="onSort($event)"> </th>
                </div>
              </th>
              <th scope="col" class="filtre only-large-screen" style="width: 100px">
                <!-- {{'DOCUMENTS.SECTOR' | translate}} -->
                <div style="display: flex;">
                  <mat-form-field appearance="legacy" style="width: 95px" >
                    <mat-icon matSuffix style="font-size:x-small;">filter_list</mat-icon>
                    <input type="text"
                          placeholder="{{'DOCUMENTS.SECTOR' | translate}}"
                          aria-label="Number"
                          matInput
                          [(ngModel)]="allSector"
                          name="allSector"
                          [formControl]="myControlTitle"
                          [matAutocomplete]="auto"
                          (keyup)="inputChange($event, 'allSector')"
                          [id]="allSector" 
                          >
                    <!-- <mat-autocomplete #auto="matAutocomplete">
                      <mat-option *ngFor="let infos of filteredOptions | async" [value]="name">
                        {{name}}
                      </mat-option>
                    </mat-autocomplete> -->
                  </mat-form-field>
                  <th  class="sorticone" sortable="allSector" (sort)="onSort($event)"> </th>
                </div>
              </th>
  
              <th style="width: 60px; text-align: center;vertical-align: middle;">{{'DOCUMENTS.DOWNLOAD' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr *ngFor="let document of documentView  | async"> -->
            <tr *ngFor="let document of dataSourceDocs$ | async">
              <td>
                <div [ngClass]="document.type" class="icon"></div>
              </td>
              <td filter="{ 'name': 'text' }">
                {{ document.name }}
              </td>
              <td class="only-large-screen" >{{ document.dateModified | appDate: 'mediumDate'  }}</td>
              <td class="only-large-screen">{{ document.author }}</td>
              <td class="only-large-screen">{{ document.type_doc}}</td>
              <td class="only-large-screen">{{ document.theme }}</td>
  
              <td class="only-large-screen">
                <span
                  *ngFor="let pad of document.allSourcefin ; let index = index; let isFirsta = first; let isOdda = odd;">
                  <!-- {{isFirsta}}
                {{isOdda}}
                {{document.allSourcefin.length}} -->
                  {{(document.allSourcefin.length==1 || index == (document.allSourcefin.length-1)) ? pad[1] : pad[1]+',  '}}
                </span>
              </td>
              <td class="only-large-screen">
                <span
                  *ngFor="let sector of document.allSector ;let index = index; let isFirstb = first; let isOddb = odd;">
                  <br>
                  {{(document.allSector.length==1 || index == (document.allSector.length-1)) ? sector[1] : sector[1]+',  '}}
  
                </span>
              </td>
  
              <td class="download">
                <a (click)="downloadItem(document)">
                  <svg width="24" height="24" fill="#1D6529" stroke="#1D6529" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512">
                    <!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) -->
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                      stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
  
  
                  <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7366 2.76175H8.08461C6.00461 2.75375 4.30061 4.41075 4.25061 6.49075V17.2277C4.20561 19.3297 5.87361 21.0697 7.97461 21.1147C8.01161 21.1147 8.04861 21.1157 8.08461 21.1147H16.0726C18.1626 21.0407 19.8146 19.3187 19.8026 17.2277V8.03775L14.7366 2.76175Z" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14.4749 2.75V5.659C14.4749 7.079 15.6239 8.23 17.0439 8.234H19.7979" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M11.6409 9.90869V15.9497" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M13.9866 12.2642L11.6416 9.90918L9.2966 12.2642" stroke="#1D6529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg> -->
  
                </a>
  
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="paging-content" *ngIf="documentView.length > 0 && !loading">
        <div class="paging">
          <div class="first-page" *ngIf="currentPage !== 1">
            <button (click)="currentPage = 1">
              << </button>
          </div>
          <div class="prev-page" *ngIf="currentPage !== 1">
            <button (click)="currentPage = currentPage - 1">
              < </button>
          </div>
          <div *ngFor="let page of pages">
            <button [ngClass]="currentPage === page ? 'active' : ''" (click)="currentPage = page">{{page}}</button>
          </div>
          <div class="next-page" *ngIf="currentPage !== pages.length">
            <button (click)="currentPage = currentPage + 1"> > </button>
          </div>
          <div class="last-page" *ngIf="currentPage !== pages.length">
            <button (click)="currentPage = pages.length"> >> </button>
          </div>
        </div>
        <div class="summary">
          <span>
            {{'DOCUMENTS.PAGING' | translate: {current: currentPage,  total: pages.length,  files: documents.length } }}</span>
        </div>
      </div>
      <div *ngIf="documentView.length === 0 && !loading" style="text-align: center;padding: 15%;">
        <h2>{{'COMMON.NO_DOCS' | translate}}</h2>
      </div>
    </div>
    <div class="space"></div>
  </div>
</form>